type ChipDisplayLabelItem = {
  label?: string;
};

export const normalizeKeyForUiMessaging = (key: string): string =>
  key?.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() || '';

export const generateAlternateKey = (key: string, prefix: string): string =>
  `${prefix}_${normalizeKeyForUiMessaging(key)}`;

export const getAlternateChipNameFromLagoon = (
  key: string,
  uiMessaging?: any[]
) => {
  if (!key) return undefined;

  const alternateKey = generateAlternateKey(key, 'ALTERNATE_CHIP_NAME_FOR');

  return uiMessaging?.find((message) => message?.key === alternateKey);
};

export const getChipDisplayLabel = (
  item: ChipDisplayLabelItem,
  uiMessaging?: any[],
  t?: (key: string) => string
): string => {
  const key = item?.label || '';
  const alternateValue = getAlternateChipNameFromLagoon(key, uiMessaging);

  return alternateValue?.title || (t ? t(key) : key);
};

export const getFilterDisplayLabel = (
  label?: string,
  uiMessaging?: any[],
  t?: (key: string) => string
): string => {
  if (!label) return '';

  const alternateKey = generateAlternateKey(label, 'ALTERNATE_FILTER_NAME_FOR');
  const alternateValue = uiMessaging?.find(
    (message) => message?.key === alternateKey
  );

  return alternateValue?.message || (t ? t(label) : label);
};
